import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { CakeItemVariant } from '../cake-item-variant';

/** Card of a catering menu: "See variants" on hover, or the cart controls once a menu build is in the cart. */
@Component({
  standalone: true,
  selector: 'cake-item-catering',
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass, NgTemplateOutlet, RouterLink, TranslateModule],
  templateUrl: './cake-item-catering.component.html',
})
export class CakeItemCateringComponent extends CakeItemVariant {
  hasCartLines = input(false);
  /** touch: the controls were revealed by a first tap */
  controlsVisible = input(false);
  /** touch with a build in the cart: the overlay takes no taps until the controls are revealed */
  touchLocked = input(false);

  open = output<void>();
  edit = output<void>();
  remove = output<void>();
}
